/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/angularjs/angular-js.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import visionics from "vics/visionics/js/main";
import { AngularJsComponent } from "./angular-js.component";
import * as i0 from "@angular/core";
export class AngularJsModule {
    constructor() {
        // Load visionics into this module so it is's active.
        this.v = visionics;
    }
}
AngularJsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    AngularJsComponent,
                ],
                exports: [
                    AngularJsComponent,
                ],
            },] },
];
/** @nocollapse */
AngularJsModule.ctorParameters = () => [];
/** @nocollapse */ AngularJsModule.ɵmod = i0.ɵɵdefineNgModule({ type: AngularJsModule });
/** @nocollapse */ AngularJsModule.ɵinj = i0.ɵɵdefineInjector({ factory: function AngularJsModule_Factory(t) { return new (t || AngularJsModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AngularJsModule, { declarations: [AngularJsComponent], exports: [AngularJsComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AngularJsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AngularJsComponent,
                ],
                exports: [
                    AngularJsComponent,
                ],
            }]
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AngularJsModule.prototype.v;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5ndWxhci1qcy5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9hbmd1bGFyanMvYW5ndWxhci1qcy5tb2R1bGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxPQUFPLEVBQUMsUUFBUSxFQUFDLE1BQU0sZUFBZSxDQUFDO0FBQ3ZDLE9BQU8sU0FBUyxNQUFNLHdCQUF3QixDQUFDO0FBRS9DLE9BQU8sRUFBQyxrQkFBa0IsRUFBQyxNQUFNLHdCQUF3QixDQUFDOztBQVUxRCxNQUFNLE9BQU8sZUFBZTtJQUcxQjs7UUFEUSxNQUFDLEdBQUcsU0FBUyxDQUFDO0lBQ1AsQ0FBQzs7O1lBWGpCLFFBQVEsU0FBQztnQkFDUixZQUFZLEVBQUc7b0JBQ2Isa0JBQWtCO2lCQUNuQjtnQkFDRCxPQUFPLEVBQUc7b0JBQ1Isa0JBQWtCO2lCQUNuQjthQUNGOzs7O21EQUNZLGVBQWU7NkdBQWYsZUFBZTt3RkFBZixlQUFlLG1CQU54QixrQkFBa0IsYUFHbEIsa0JBQWtCO2tEQUdULGVBQWU7Y0FSM0IsUUFBUTtlQUFDO2dCQUNSLFlBQVksRUFBRztvQkFDYixrQkFBa0I7aUJBQ25CO2dCQUNELE9BQU8sRUFBRztvQkFDUixrQkFBa0I7aUJBQ25CO2FBQ0Y7Ozs7Ozs7SUFHQyw0QkFBc0IiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHZpc2lvbmljcyBmcm9tIFwidmljcy92aXNpb25pY3MvanMvbWFpblwiO1xuXG5pbXBvcnQge0FuZ3VsYXJKc0NvbXBvbmVudH0gZnJvbSBcIi4vYW5ndWxhci1qcy5jb21wb25lbnRcIjtcblxuQE5nTW9kdWxlKHtcbiAgZGVjbGFyYXRpb25zIDogW1xuICAgIEFuZ3VsYXJKc0NvbXBvbmVudCxcbiAgXSxcbiAgZXhwb3J0cyA6IFtcbiAgICBBbmd1bGFySnNDb21wb25lbnQsXG4gIF0sXG59KVxuZXhwb3J0IGNsYXNzIEFuZ3VsYXJKc01vZHVsZSB7XG4gIC8vIExvYWQgdmlzaW9uaWNzIGludG8gdGhpcyBtb2R1bGUgc28gaXQgaXMncyBhY3RpdmUuXG4gIHByaXZhdGUgdiA9IHZpc2lvbmljcztcbiAgY29uc3RydWN0b3IoKSB7fVxufVxuIl19